import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { OptionListWrapper } from './options-list/OptionList';
import { useIntl } from 'react-intl';

const OptionPage = () => {
  const intl = useIntl(); 

  const optionsBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'OPTION_PAGE.BREADCRUMB' }), 
      path: '/apps/option-management/options',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='options'
          element={
            <>
              <PageTitle breadcrumbs={optionsBreadcrumbs}>
                {intl.formatMessage({ id: 'OPTION_PAGE.TITLE' })}
              </PageTitle>
              <OptionListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/Option-management/options' />} />
    </Routes>
  );
};

export default OptionPage;